<template>
    <UApp :locale="uiLocale">
        <UTheme :props="uiDefaults">
            <!-- The hotel has not bought this module, so there is no day to draw and no
                 screen underneath that could answer. It replaces the app rather than
                 sitting inside a layout: the navigation would offer tabs that are all
                 refused. -->
            <ModuleNotice v-if="moduleUnlicensed" />

            <component :is="layout" v-else>
                <router-view />
            </component>
        </UTheme>
    </UApp>
</template>

<script lang="ts" setup>
    import * as locales from '@nuxt/ui/locale'
    import { computed, onMounted } from 'vue'
    import { useI18n } from 'vue-i18n'
    import { useRoute } from 'vue-router'

    import ModuleNotice from '@/components/ModuleNotice.vue'
    import Blank   from '@/layouts/Blank.vue'
    import Default from '@/layouts/Default.vue'
    import { moduleUnlicensed } from '@/libs/license'
    import { uiDefaults } from '@/libs/uiDefaults'
    import { usePointerGuard } from '@/libs/pointerGuard'

    const route = useRoute()
    const { locale } = useI18n()

    // Keeps Nuxt UI's built-in component texts in sync with the vue-i18n locale.
    const uiLocale = computed(() => (locales as Record<string, typeof locales.en>)[locale.value] ?? locales.en)

    const layouts = { Default, Blank }
    const layout  = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default'])

    // Watches for the click lock a closed dialog can leave on the page. The portal is
    // used on a telephone, where a page that stops responding is even harder to explain
    // than at a desk — and a housekeeper cannot be asked to reload it.
    onMounted(usePointerGuard)
</script>
